
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import {
    getGrecaptchaResponse,
    injectGrecaptchaScript,
    render,
} from '@/utils/grecaptcha'

@Component<GrecaptchaBox>({})
export default class GrecaptchaBox extends Vue {
    @Prop({ type: String, required: true }) public sitekey!: string

    public recaptchaId = 0

    public async beforeMount() {
        await injectGrecaptchaScript()
        await this.renderGrecaptcha()
    }

    public async renderGrecaptcha() {
        const recaptcha = document.getElementById('g-recaptcha') as HTMLElement
        this.recaptchaId = render(recaptcha, this.sitekey)
    }

    public getResponse() {
        return getGrecaptchaResponse(this.recaptchaId)
    }
}
